// @flow

import React, { PureComponent } from 'react';
import { formatPhoneNumber } from 'client/utils/format';
import Translate from 'client/components/translate';

type Props = {
  message: string,
  phoneNumber: string,
};

class TextSuccessMessage extends PureComponent<Props> {
  render() {
    const { message, phoneNumber } = this.props;
    const formattedPhone = formatPhoneNumber(phoneNumber);

    return (
      message && (
        <p className="semi-bold">
          <Translate path="" fallback={message} using={{ phoneNumber: formattedPhone }} />
        </p>
      )
    );
  }
}

export default TextSuccessMessage;
